import * as z from "zod";

// Per-network alert enrollment status for the settings cards. The wire shape is
// declared here (not imported from the Disputely HTTP client) to keep that
// server-only client out of the browser SDK bundle; it mirrors
// NormalizedAlertNetworkStatus. Status strings are open (vendor §12.2) — kept as
// plain strings so an unknown value renders rather than failing validation.
const alertNetworks = ["CDRN", "ETHOCA", "RDR"] as const;

const descriptorEntrySchema = z.object({
  value: z.string(),
  status: z.string(),
  reason: z.string().nullish(),
});

const binEntrySchema = z.object({
  id: z.string().nullish(),
  bin: z.string().nullish(),
  caid: z.string().nullish(),
  status: z.string(),
  reason: z.string().nullish(),
});

export const disputelyAlertNetworkStatusSchema = z.object({
  network: z.enum(alertNetworks),
  enrolled: z.boolean(),
  status: z.string().nullable(),
  descriptors: z.array(descriptorEntrySchema),
  bins: z.array(binEntrySchema),
});

export const getDisputelyAlertStatus = {
  name: "getDisputelyAlertStatus" as const,
  input: z.object({}),
  output: z.object({
    provisioned: z.boolean(),
    networks: z.array(disputelyAlertNetworkStatusSchema),
  }),
};
